import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'
import { modalScheduleSendingState } from '../../recoil/state/modals'
import { sendingScheduleSetImmediateCallback } from '../../recoil/callbacks/callbacks'
import { ModalBody, Text, Flex } from 'mailup-web-components'
import { Foot } from './Foot'

export const ContentImmediate = () => {
  const intl = useIntl()

  const confirm = useRecoilCallback(sendingScheduleSetImmediateCallback, [])
  const cancel = useResetRecoilState(modalScheduleSendingState)
  const { idSending, countImmediate } = useRecoilValue(
    modalScheduleSendingState
  )

  return (
    <>
      <ModalBody>
        <Flex flexDirection='column' rowGap='16px'>
          <Text>
            {intl.formatMessage({
              id: 'Load.Schedulation.SendTypeSequenzialeText'
            })}
          </Text>
          <Text>
            {intl.formatMessage(
              {
                id: 'Load.Schedulation.SendTypeSequenzialeDescription'
              },
              {
                strong: chunks => <strong>{chunks}</strong>,
                count: countImmediate
              }
            )}
          </Text>
        </Flex>
      </ModalBody>
      <Foot onClickCancel={cancel} onClickConfirm={() => confirm(idSending)} />
    </>
  )
}
